import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';

@Injectable()
export class StudyDocumentService {

  constructor(
    private http: HttpClient
  ) { }

  addFile(file, callback) {
    const formData = new FormData();
    formData.append('file', file);
    const headers = new HttpHeaders().set('no-content-type', 'true');
    this.http.post('/study-document/files', formData, { headers }).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  removeFile(file, payload, callback) {
    this.http.put('/study-document/files/' + file.enc_name + '/' + file.extension + '/delete', payload).subscribe(
      res => {
        callback(null, res);
      },
      err => {
        callback(err);
      }
    );
  }

  createOrUpdate(payload, callback) {
    if (payload.id) {
      this.http.put('/study-document/' + payload.id, payload).subscribe(
        res => { callback(null, res); },
        callback
      );
    } else {
      this.http.post('/study-document', payload).subscribe(
        res => { callback(null, res); },
        callback
      );
    }
  }

  getAll(programmeId, classId, callback) {
    this.http.get('/programme/study-document/' + programmeId + '/' + classId).subscribe(
      res => {
        callback(null, res);
      },
      callback
    );
  }

  delete(id, callback) {
    this.http.delete('/study-document/' + id).subscribe(
      res => {
        callback(null, res);
      },
      callback
    );
  }

}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/services/study-document/study-document.service.ts